import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store'
import * as fromAuth from './auth.reducer'
import { ProfileTypeEnum } from 'libs/gb-front/selected-profile/data-access/src/lib/+state/selected-profile.models'

export interface SelectorState {
  auth: fromAuth.AuthenticationState
}

export const reducers: ActionReducerMap<SelectorState> = {
  auth: fromAuth.reducer,
}

export const selectAuthState = createFeatureSelector<fromAuth.AuthenticationState>(fromAuth.AUTH_FEATURE_KEY)

export const selectAuthentication = createSelector(selectAuthState, (authState) => authState)

export const selectAuthProfile = createSelector(selectAuthState, (authState) => {
  return authState ? authState.profile : undefined
})

export const selectAuthProfileId = createSelector(selectAuthState, (authState) =>
  authState && authState.profile && authState.profile.uuid ? authState.profile.uuid : undefined,
)

export const selectAuthUserProfile = createSelector(selectAuthState, (authState) =>
  authState && authState.profile && authState.profile.profile ? authState.profile.profile : undefined,
)

export const selectAuthToken = createSelector(selectAuthState, (authState) => (authState ? authState.token : undefined))

export const selectIsAuthenticated = createSelector(selectAuthState, (authState) => authState && !!authState.token)

export const selectAuthType = createSelector(selectAuthState, (authState) =>
  authState && authState.profile ? authState.profile.type : undefined,
)

export const selectIsVerficationEnabled = createSelector(selectAuthState, (authState) =>
  authState && authState.profile ? authState.profile.enable_verification : true,
)

export const selectIsVolunteer = createSelector(selectAuthState, (authState) =>
  authState && authState.profile ? authState.profile.type === ProfileTypeEnum.Volunteer : false,
)

export const selectIsGuest = createSelector(selectAuthState, (authState) =>
  authState && authState.profile ? authState.profile.type === ProfileTypeEnum.Guest : false,
)

export const selectAuthVerifyError = createSelector(selectAuthState, (authState) =>
  authState.errors && authState.errors.verify ? authState.errors.verify : '',
)

export const selectPasswordRequired = createSelector(selectAuthProfile, (profile) => profile?.password_required)

export const selectHasVouchers = createSelector(selectAuthProfile, (profile) => profile?.has_vouchers)

export const selectFavouriteItems = createSelector(selectAuthProfile, (profile) => profile?.favourite_items || [])

export const selectHasFavouriteItems = createSelector(
  selectAuthProfile,
  (profile) => profile && (profile.favourite_items_count || 0) > 0,
)

export const getIsItemFavourited = (uuid: string) =>
  createSelector(selectFavouriteItems, (favouriteItems) => favouriteItems.some((id) => id === uuid))
